import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import TextBox from 'components/ui/TextBox';
import NumberFormat from 'react-number-format';

const FullWidthInput = styled(TextBox)`
  width: 100%;
`;

const PaymentAmountInput = ({ values, errors, touched, setFieldValue, disabled }) => {
  const handleChange = event => {
    setFieldValue('amount', event.target.value.replace('$', '')); // removes prefix
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={`${getTranslatedString('landlordPortal.batch.payments.amount')}*`}
            validateStatus={touched.amount && errors.amount ? 'error' : null}
            help={touched.amount && errors.amount}
          >
            <NumberFormat
              name="amount"
              value={values.amount}
              thousandSeparator={true}
              allowNegative={false}
              decimalScale={2}
              fixedDecimalScale={true}
              prefix="$"
              placeholder={getTranslatedString('landlordPortal.batch.payments.amount.placeHolder')}
              customInput={FullWidthInput}
              size="large"
              onChange={handleChange}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
      </Row>
    </Spacer>
  );
};

export default PaymentAmountInput;
